import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginForm from '../components/forms/LoginForm';
import RegistrationForm from '../components/forms/RegistrationForm';
import PasswordReset from '../components/forms/PasswordReset';

const AuthRoutes = () => (
  <Routes>
    <Route path="login" element={<LoginForm />} />
    <Route path="register" element={<RegistrationForm />} />
    <Route path="forgot-password" element={<PasswordReset />} />
    <Route path="*" element={<Navigate to="/auth/login" replace />} />
  </Routes>
);

export default AuthRoutes;